import React from 'react';

export default function Team1(): JSX.Element {
  return (
    <>
      <svg
        id="ae636c83-9a69-4d8f-8683-8786b472330f"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="520"
        height="346"
        viewBox="0 0 643.45103 542.33898"
      >
        <ellipse cx={567} cy={537} rx={70} ry="5.33898" fill="#e6e6e6" />
        <ellipse cx={226} cy={537} rx={70} ry="5.33898" fill="#e6e6e6" />
        <path
          d="M814.77448,650.83051h-476a7.5082,7.5082,0,0,1-7.5-7.5v-457a7.5082,7.5082,0,0,1,7.5-7.5h476a7.5082,7.5082,0,0,1,7.5,7.5v457A7.5082,7.5082,0,0,1,814.77448,650.83051Zm-476-469a4.50492,4.50492,0,0,0-4.5,4.5v457a4.50493,4.50493,0,0,0,4.5,4.5h476a4.50492,4.50492,0,0,0,4.5-4.5v-457a4.50491,4.50491,0,0,0-4.5-4.5Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          d="M366.27448,218.83051a3.00328,3.00328,0,0,0-3,3v124a3.00328,3.00328,0,0,0,3,3h124a3.00328,3.00328,0,0,0,3-3v-124a3.00328,3.00328,0,0,0-3-3Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          id="b9d15c13-74bb-46fd-a6fd-5a7002be597d"
          data-name="Path 40"
          d="M561.31441,308.581a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,1,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          id="fb98932a-aea9-43a1-946e-96a095a0002f"
          data-name="Path 40"
          d="M561.31441,275.581a3.625,3.625,0,0,0,0,7.249h48.878a3.625,3.625,0,1,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          id="a8382d7c-76a2-4f66-b41d-b5784413a475"
          data-name="Path 40"
          d="M561.31441,342.581a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          id="a69b3c31-ebec-4776-89b9-9c88b713759e"
          data-name="Path 78"
          d="M764.58325,473.54293h-234.838c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9v51.041C772.87226,470.899,769.16126,473.53893,764.58325,473.54293Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          id="ac481be8-039b-4a38-bb10-2d9a81406e5c"
          data-name="Path 78"
          d="M605.58325,597.54293h-234.838c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9v51.041C613.87226,594.899,610.16126,597.53893,605.58325,597.54293Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          id="e05581d0-cd6a-412e-af3c-57495fab8d46"
          data-name="Path 78"
          d="M534.74073,625.661h-234.838c-4.578,0-8.288-2.643-8.293-5.9V568.719c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9V619.76C543.02974,623.017,539.31874,625.657,534.74073,625.661Zm-234.838-60.484c-2.747,0-4.973,1.586-4.976,3.54v51.041c0,1.954,2.229,3.538,4.976,3.54h234.838c2.747,0,4.973-1.586,4.976-3.54V568.719c0-1.954-2.229-3.538-4.976-3.54Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
        <circle cx={341} cy={288} r={19} fill="#f9a826" />
        <circle cx={56} cy={415} r={19} fill="#f9a826" />
        <path
          id="f4993879-8a0d-4ea4-907e-e549be7081a0"
          data-name="Path 40"
          d="M660.31441,453.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
        <path
          id="a649136c-96b9-48c7-9686-75389104c34a"
          data-name="Path 40"
          d="M660.31441,473.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
        <path
          id="bf4cb793-0df2-4753-9628-c376ea3545d1"
          data-name="Path 40"
          d="M375.31441,580.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
        <path
          id="bf2170fd-291c-4664-b596-01f8e04656d6"
          data-name="Path 40"
          d="M375.31441,600.206a3.625,3.625,0,0,0,0,7.249h135.878a3.625,3.625,0,0,0,.119-7.249q-.05951-.001-.119,0Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
        <circle cx="568.97297" cy="475.93056" r="43.06733" fill="#2f2e41" />
        <rect
          x="575.51484"
          y="509.73025"
          width="13.08374"
          height="23.44171"
          fill="#2f2e41"
        />
        <rect
          x="549.34736"
          y="509.73025"
          width="13.08374"
          height="23.44171"
          fill="#2f2e41"
        />
        <ellipse
          cx="577.6955"
          cy="533.44455"
          rx="10.90314"
          ry="4.08868"
          fill="#2f2e41"
        />
        <ellipse
          cx="551.52796"
          cy="532.89938"
          rx="10.90314"
          ry="4.08868"
          fill="#2f2e41"
        />
        <circle cx="567.88264" cy="465.02746" r="14.71922" fill="#fff" />
        <circle cx="567.88264" cy="465.02746" r="4.90642" fill="#3f3d56" />
        <path
          d="M889.02425,614.70972c3.47747-15.57379-7.63868-31.31043-24.82862-35.14881s-33.94421,5.67511-37.42169,21.24891,7.91492,21.31768,25.10486,25.156S885.54671,630.28357,889.02425,614.70972Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#e6e6e6"
        />
        <path
          d="M388.58448,368.79047a42.8306,42.8306,0,0,1-4.43,19.04c-.33.68-.68,1.34-1.05,2h-75.17c-.37-.66-.72-1.32-1.05-2a43.07126,43.07126,0,1,1,81.7-19.04Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#2f2e41"
        />
        <circle cx="68.33625" cy="179.05228" r="14.71922" fill="#fff" />
        <circle cx="68.33625" cy="179.05228" r="4.90642" fill="#3f3d56" />
        <path
          d="M303.74361,328.73454c-3.47748-15.57379,7.63867-31.31043,24.82861-35.14881s33.94422,5.67511,37.42169,21.24891-7.91491,21.31768-25.10485,25.156S307.22115,344.30839,303.74361,328.73454Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#f9a826"
        />
        <path
          d="M407.27448,255.83051h-124a5.00181,5.00181,0,0,0-5,5v124a5.00181,5.00181,0,0,0,5,5h124a5.00181,5.00181,0,0,0,5-5v-124A5.00181,5.00181,0,0,0,407.27448,255.83051Zm3,129a3.00883,3.00883,0,0,1-3,3h-124a3.00883,3.00883,0,0,1-3-3v-124a3.00879,3.00879,0,0,1,3-3h124a3.00878,3.00878,0,0,1,3,3Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
        <ellipse
          cx="537.06537"
          cy="622.23907"
          rx="21.53369"
          ry="6.76007"
          transform="translate(-514.18629 722.92057) rotate(-69.08217)"
          fill="#2f2e41"
        />
        <circle
          cx="497.2582"
          cy="654.76108"
          r="43.06735"
          transform="translate(-506.97468 861.88678) rotate(-80.78252)"
          fill="#2f2e41"
        />
        <rect
          x="199.35811"
          y="509.73025"
          width="13.08374"
          height="23.44171"
          fill="#2f2e41"
        />
        <rect
          x="225.52559"
          y="509.73025"
          width="13.08374"
          height="23.44171"
          fill="#2f2e41"
        />
        <ellipse
          cx="210.26125"
          cy="533.44455"
          rx="10.90314"
          ry="4.08868"
          fill="#2f2e41"
        />
        <ellipse
          cx="236.42873"
          cy="532.89941"
          rx="10.90314"
          ry="4.08868"
          fill="#2f2e41"
        />
        <path
          d="M455.48148,614.70969c-3.47748-15.57379,7.63867-31.31046,24.82861-35.14884s33.94421,5.67508,37.42169,21.24887-7.91492,21.31766-25.10486,25.156S458.959,630.28351,455.48148,614.70969Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#f9a826"
        />
        <ellipse
          cx="448.75004"
          cy="634.77768"
          rx="6.76007"
          ry="21.53368"
          transform="translate(-595.36631 589.38455) rotate(-64.62574)"
          fill="#2f2e41"
        />
        <circle cx="581.96808" cy="344.64255" r="42.01233" fill="#2f2e41" />
        <rect
          x="866.8304"
          y="556.38495"
          width="12.76324"
          height="22.86749"
          transform="translate(-280.90454 -174.76527) rotate(-0.26634)"
          fill="#2f2e41"
        />
        <rect
          x="841.30427"
          y="556.50355"
          width="12.76324"
          height="22.86749"
          transform="translate(-280.90537 -174.88393) rotate(-0.26634)"
          fill="#2f2e41"
        />
        <ellipse
          cx="845.09117"
          cy="581.77645"
          rx="10.63602"
          ry="3.98853"
          transform="translate(-456.30877 326.41344) rotate(-30.26634)"
          fill="#2f2e41"
        />
        <ellipse
          cx="870.08559"
          cy="581.66024"
          rx="10.63605"
          ry="3.98853"
          transform="translate(-452.84325 338.99529) rotate(-30.26634)"
          fill="#2f2e41"
        />
        <circle cx="580.85505" cy="334.01157" r="14.35864" fill="#fff" />
        <circle cx="575.93651" cy="327.91867" r="4.78622" fill="#3f3d56" />
        <path
          d="M900.81388,484.21377c3.32162-15.20789-7.5934-30.50849-24.37949-34.17481s-33.08659,5.68993-36.40825,20.89782,7.81762,20.75932,24.60367,24.4257S897.49225,499.42167,900.81388,484.21377Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#f9a826"
        />
        <ellipse
          cx="816.3671"
          cy="502.20254"
          rx="6.59448"
          ry="21.00616"
          transform="translate(-242.24392 879.91271) rotate(-67.09517)"
          fill="#2f2e41"
        />
        <ellipse
          cx="902.20392"
          cy="537.02192"
          rx="6.59448"
          ry="21.00616"
          transform="translate(-221.88888 980.24914) rotate(-67.09517)"
          fill="#2f2e41"
        />
        <path
          d="M868.73264,541.781a9.57243,9.57243,0,1,1-19.14455.10779l-.0001-.01879c-.02458-5.28665,4.256-6.40152,9.54268-6.42606S868.70809,536.49432,868.73264,541.781Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#fff"
        />
        <path
          id="acccf4df-3a09-4c7b-a8c8-af469fe66e6d"
          data-name="Path 78"
          d="M825.67774,498.49559h-234.838c-4.578,0-8.288-2.643-8.293-5.9v-51.042c.005-3.257,3.715-5.9,8.293-5.9h234.838c4.578,0,8.288,2.643,8.293,5.9v51.041C833.96674,495.85161,830.25575,498.4916,825.67774,498.49559Zm-234.838-60.484c-2.747,0-4.973,1.586-4.976,3.54v51.041c0,1.954,2.229,3.538,4.976,3.54h234.838c2.747,0,4.973-1.586,4.976-3.54v-51.039c0-1.954-2.229-3.538-4.976-3.54Z"
          transform="translate(-278.27448 -178.83051)"
          fill="#3f3d56"
        />
      </svg>
    </>
  );
}
